<template>
  <v-app>
    <v-container fluid>
      <v-card variant="outlined">
        <v-card-title class="d-flex flex-wrap align-center ga-2 bg-blue-grey-lighten-4 text-subtitle-1">
          <span>Finished-Goods Delivery List</span>
          <v-spacer />
          <v-text-field v-model="search" label="Search" prepend-inner-icon="mdi-magnify" density="compact" variant="outlined" hide-details clearable style="max-width: 280px" />
          <v-btn color="primary" prepend-icon="mdi-plus" :to="{ name: 'create-delivery' }">Send to Inventory</v-btn>
        </v-card-title>
        <v-data-table :headers="headers" :items="items" :search="search" :loading="loading" density="compact">
          <template #item.index="{ index }">{{ index + 1 }}</template>
          <template #item.production="{ item }">{{ item.production?.code || '-' }}</template>
          <template #item.warehouse="{ item }">{{ item.warehouse?.name || '-' }}</template>
          <template #item.items="{ item }">
            <div v-for="detail in item.details || []" :key="detail.id" class="text-caption">
              {{ detail.product?.name }} · {{ detail.batch_no || detail.production_detail?.batch_no || '-' }} · {{ number(detail.quantity) }}
            </div>
          </template>
          <template #item.approval_status="{ item }">
            <v-chip size="small" :color="approvalColor(item.approval_status)">{{ item.approval_status || (item.status ? 'Pending' : 'Draft') }}</v-chip>
          </template>
          <template #item.actions="{ item }">
            <v-btn icon="mdi-file-document-outline" color="blue" variant="text" size="small" :to="{ name: 'production-delivery-details', params: { id: item.id } }" />
            <v-btn v-if="canEdit(item) && $updateAccess($route.path)" icon="mdi-pencil-outline" color="primary" variant="text" size="small" :to="{ name: 'create-delivery', params: { id: item.id } }" />
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";

const store = useStore();
const search = ref("");
const loading = ref(false);
const items = computed(() => store.getters.getPrdDeliveryList || []);
const headers = [
  { title: "#", key: "index", sortable: false },
  { title: "Code", key: "code" },
  { title: "Production", key: "production" },
  { title: "Delivery Date", key: "delivery_date" },
  { title: "Destination", key: "warehouse" },
  { title: "Products / Batch / Qty", key: "items", sortable: false },
  { title: "Approval", key: "approval_status" },
  { title: "Actions", key: "actions", sortable: false },
];

function number(value) {
  return Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: 4 });
}

function approvalColor(status) {
  if (status === "Approved") return "success";
  if (status === "Cancelled" || status === "Rejected") return "error";
  return "warning";
}

function canEdit(item) {
  return !item.posted_at && !item.approval_current_process && (!item.approval_status || item.approval_status === "Pending") && Number(item.status) === 0;
}

onMounted(async () => {
  loading.value = true;
  try {
    await store.dispatch("getPrdDeliveryList");
  } catch (error) {
    toast.error(error?.response?.data?.message || "Finished-goods delivery list could not be loaded.");
  } finally {
    loading.value = false;
  }
});
</script>
